import * as React from 'react';
import { SVGProps } from 'react';

const IconBookSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5 4a2 2 0 0 1 2-2h1v13l2.5-1.083L13 15V2h8a2 2 0 0 1 2 2v16H9a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h14v1a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4Z" />
  </svg>
);
export default IconBookSizeL;
